import React, { useState, useEffect } from 'react'
import Backdrop from '../Backdrop/Backdrop'
import Button from '../Button/index'
import Typography from '../Typography/index'
import { IoClose, IoDesktopOutline, IoPhonePortraitOutline } from 'react-icons/io5'

const MobileWarningModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Check if user has dismissed the modal before
    const hasSeenWarning = localStorage.getItem('mobileWarningDismissed')

    // Detect mobile device
    const checkMobileDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const isMobileDevice =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
      const isSmallScreen = window.innerWidth < 1024 // Less than 1024px (tablet/mobile)

      return isMobileDevice || isSmallScreen
    }

    const mobile = checkMobileDevice()
    setIsMobile(mobile)

    // Show modal if on mobile and hasn't been dismissed
    if (mobile && !hasSeenWarning) {
      setIsOpen(true)
    }

    // Add resize listener
    const handleResize = () => {
      const mobile = checkMobileDevice()
      setIsMobile(mobile)

      const hasSeenWarning = localStorage.getItem('mobileWarningDismissed')
      if (mobile && !hasSeenWarning) {
        setIsOpen(true)
      } else if (!mobile) {
        setIsOpen(false)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleDismissForever = () => {
    localStorage.setItem('mobileWarningDismissed', 'true')
    setIsOpen(false)
  }

  if (!isMobile || !isOpen) return null

  return (
    <Backdrop isOpen={isOpen} onClose={handleClose}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-[90vw] sm:w-full mx-auto p-4 sm:p-6 relative">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors z-10"
          aria-label="Close"
        >
          <IoClose className="text-xl sm:text-2xl" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-3 sm:mb-4 mt-2">
          <div className="relative">
            <IoPhonePortraitOutline className="text-5xl sm:text-6xl text-orange-500" />
            <IoDesktopOutline className="text-3xl sm:text-4xl text-blue-500 absolute -right-5 sm:-right-6 -bottom-2" />
          </div>
        </div>

        {/* Title */}
        <Typography variant="h3" className="text-center font-bold text-gray-800 mb-2 sm:mb-3 text-lg sm:text-xl">
          Better Experience on Desktop
        </Typography>

        {/* Message */}
        <Typography variant="body" className="text-center text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base px-2">
          For the best experience with analytics and dashboards, we recommend using a laptop or desktop device with a
          larger screen. Many features are optimized for wider displays.
        </Typography>

        {/* Buttons */}
        <div className="flex flex-col gap-2 sm:gap-3">
          <Button variant="primary" className="w-full text-sm sm:text-base py-2" onClick={handleClose}>
            Continue Anyway
          </Button>
          <Button variant="secondary" className="w-full text-sm sm:text-base py-2" onClick={handleDismissForever}>
            Don't Show Again
          </Button>
        </div>
      </div>
    </Backdrop>
  )
}

export default MobileWarningModal
